﻿import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder"
import NullableMoneyObservable from "../observables/nullablemoneyobservable";
import Utility from "../utility"
import ko from 'knockout';
import $ from 'jquery';


export class MoneyInputBinder implements IBinder {
  public getElements(row: JQuery): JQuery {
    return row.find("input[type='text'].money-field");
  }

  public getBinding(cell: JQuery): ICellBinding {
    var cellName = cell.attr("name");

    return {
      dataName: cellName,
      dataValue: new NullableMoneyObservable(cell.val()),
      bindingName: "init, autoMoney",
      bindTo: cellName,
      createEmptyValue: () => new NullableMoneyObservable()
    }
  }
}


ko.bindingHandlers.autoMoney = {
  init: (el, valueAccessor, bindingsAccessor, viewModel) => {
    var pF: any = parseFloat;
    var $el: any = $(el),
      settings = { aSign: '', vMin: '-999999999.99' },
      value = valueAccessor();
    $el.autoNumeric(settings);

    var numericValue = pF(ko.utils.unwrapObservable(value()), 10);
    if ((isNaN(numericValue) || !numericValue) && numericValue !== 0)
      numericValue = null;
    else
      numericValue = Utility.formatMoney(numericValue);

    $el.autoNumeric('set', numericValue);
    $el.change(() => {
      value(pF($el.autoNumeric('get'), 10));
    });
  },
  update: (el, valueAccessor, bindingsAccessor, viewModel) => {
    var $el: any = $(el),
      unwrapped = ko.utils.unwrapObservable(valueAccessor());

    var newValue = ((isNaN(unwrapped) || !unwrapped) && unwrapped !== 0) ? null
      : Utility.formatMoney(unwrapped);

    var elementValue = $el.autoNumeric('get'),
      valueHasChanged = (newValue != elementValue);

    if (valueHasChanged) {
      $el.autoNumeric('set', newValue);
    }
  },
};
